export default __webpack_public_path__ + "static/media/BiowelOrd.ab50795f.svg";